import {
    BackendType,
    FrontendType,
    ObjectType,
    StarjackDate,
} from '@/models/general';
import { Money } from '@/models/money';
import { convertDateFromDateArray } from '@/utils/time';

export type Coupon<T extends ObjectType = FrontendType> = {
    active: boolean;
    id: string;
    name: string;
    amount: Money;
    validFrom?: StarjackDate<T>;
    validUntil: StarjackDate<T>;
    codes: Code[];
};

export type CreateCoupon<T extends ObjectType = FrontendType> = {
    name: string;
    active: boolean;
    contingent: string;
    amount: Money;
    validFrom?: T extends FrontendType ? Date : string;
    validUntil: T extends FrontendType ? Date : string;
    codes: string;
};

export type Code = {
    code: string;
    contingent: number;
    id: string;
    used: number;
};

export const createNewCoupon = (): CreateCoupon => ({
    name: '',
    active: true,
    codes: '',
    contingent: '',
    amount: {
        amount: 0,
        currency: 'EUR',
    },
    validFrom: null,
    validUntil: null,
});

export const convertCouponFromResponse = (
    coupon: Coupon<BackendType>
): Coupon => ({
    ...coupon,
    validFrom: convertDateFromDateArray(coupon.validFrom),
    validUntil: convertDateFromDateArray(coupon.validUntil),
});

export const getNUmberFromContingent = (contingent: string): number | null => {
    const number = parseInt(contingent, 10);
    return isNaN(number) ? null : number;
};

export const isOfTypeCoupon = (
    toBeDetermined: CreateCoupon | Coupon
): toBeDetermined is Coupon => {
    return !!(toBeDetermined as Coupon)?.id;
};

export const isCreateCouponComplete = (contingent: CreateCoupon): boolean => {
    return (
        contingent.name !== '' &&
        contingent.codes !== '' &&
        contingent.contingent !== '' &&
        contingent.amount.amount > 0 &&
        contingent.validUntil !== null
    );
};
